import { createElement as _createElement } from "react";
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useTable } from "react-table";
import { addViewportIsMobileListener, isNotUndefined, isUndefined, unitedStatesIsoCode } from "../../FunctionsCore";
import { LoadingState } from "../../Internal";
import { PaginationElementComponent } from "../../PaginationElementComponent/PaginationElementComponent";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../../RenderIdentifier";
import ContactCrawlComponentsStyles from "./ContactCrawlComponentsStyles.module.scss";
const styles = ContactCrawlComponentsStyles;
const classCombiner = classCombinerFromPrefix("82e1c58f82107340");
const ContactNameComponent = (props) => {
    const { familyName, givenName, url } = props;
    return _jsxs("a", Object.assign({ href: url }, { children: [givenName, " ", familyName] }));
};
const LocationComponent = (props) => {
    const { addressCountry, addressLocality, addressRegion } = props;
    return _jsxs(_Fragment, { children: [addressLocality.length > 0 ? `${addressLocality}, ` : addressLocality, addressRegion.length > 0 ? `${addressRegion}, ` : addressRegion, addressCountry] });
};
const Tab = (props) => {
    const { contacts } = props;
    const columns = useMemo(() => [
        {
            "Header": "Contact Name",
            "accessor": ContactNameComponent,
        },
        {
            "Header": "Title",
            "accessor": (basicContact) => basicContact.title,
        },
        {
            "Header": "Company Name",
            "accessor": (basicContact) => basicContact.organizationName,
        },
        {
            "Header": "Location",
            "accessor": LocationComponent,
        },
    ], []);
    const { getTableBodyProps, getTableProps, headerGroups, prepareRow, rows } = useTable({ "columns": columns, "data": contacts });
    return (_jsx("div", { children: _jsxs("table", Object.assign({ className: cx(classCombiner(styles, "crawlDataTable")) }, getTableProps(), { children: [_jsx("thead", { children: headerGroups.map((headerGroup) => (_createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps(), { key: headerGroup.id }), headerGroup.headers.map((column) => (_createElement("th", Object.assign({}, column.getHeaderProps(), { key: column.id }), column.render("Header"))))))) }), _jsx("tbody", Object.assign({}, getTableBodyProps(), { children: rows.map((row, index) => {
                        prepareRow(row);
                        return (_createElement("tr", Object.assign({}, row.getRowProps(), { key: index }), row.cells.map((cell) => (_createElement("td", Object.assign({}, cell.getCellProps(), { key: cell.row.id + cell.column.id }), cell.render("Cell"))))));
                    }) }))] })) }));
};
const ContactCrawlComponentsComponent = (props) => {
    const { contactGroupsIndustryLocationSearchData, contactIndustrySearchData, singlePageSearchData } = props;
    const { contactIndustryLocationGroupSearchDataInner } = contactGroupsIndustryLocationSearchData;
    const { naics } = contactIndustrySearchData;
    const [contactCrawlRequestResponse, setContactCrawlRequestResponse] = useState();
    const [isMobileWidth, setIsMobileWidth] = useState(false);
    const [loadingState, setLoadingState] = useState(LoadingState.Initial);
    const [pageNumber, setPageNumber] = useState(1);
    const pageHandler = (page, contactIndustryLocationGroupSearchDataInnerParameter) => {
        const { addressCountry, addressLocality, addressRegion, } = contactIndustryLocationGroupSearchDataInnerParameter;
        setLoadingState(LoadingState.InProgress);
        setPageNumber(page);
        const addressCountryToUse = addressCountry.length > 0
            ? addressCountry
            : unitedStatesIsoCode;
        // TODO "!"
        const contactCrawlRequest = {
            "addressCountry": addressCountryToUse,
            "addressLocality": addressLocality,
            "addressRegion": addressRegion,
            "naics": naics,
            "pageNumber": page
        };
        axios
            .post("/apps/public/content/ContactCrawlDataServlet", contactCrawlRequest)
            .then((ax) => {
            setContactCrawlRequestResponse(ax.data);
            setLoadingState(LoadingState.Completed);
        });
    };
    useEffect(() => addViewportIsMobileListener((isMobile) => setIsMobileWidth(isMobile)), []);
    useEffect(() => {
        if (isUndefined(contactIndustryLocationGroupSearchDataInner)) {
            return;
        }
        if (loadingState !== LoadingState.Initial) {
            return;
        }
        pageHandler(1, contactIndustryLocationGroupSearchDataInner);
    }, [loadingState]);
    if (isUndefined(contactIndustryLocationGroupSearchDataInner)) {
        return _jsx(_Fragment, {});
    }
    // TODO Why is this being checked?
    if (isUndefined(naics) || naics.length === 0) {
        return _jsx(_Fragment, {});
    }
    if (isNotUndefined(contactCrawlRequestResponse)) {
        const { contacts, totalPages } = contactCrawlRequestResponse;
        return _jsx("div", Object.assign({ className: "container" }, { children: _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "crawl-component-container")) }, { children: [_jsx(Tab, { contacts: contacts }), _jsx("div", Object.assign({ className: cx("row") }, { children: _jsx(PaginationElementComponent, { currentPage: pageNumber, currentPageValueClassName: cx(classCombiner(styles, "current")), ellipsesClassName: cx(classCombiner(styles, "ellipses")), ltgtClassName: void 0, nextButtonClassName: cx(classCombiner(styles, "nextButton")), nextClassName: cx(classCombiner(styles, "next")), onPageChange: (nu) => pageHandler(nu, contactIndustryLocationGroupSearchDataInner), pageValueButtonClassName: cx(classCombiner(styles, "pageValue")), paginationContainerRef: void 0, previousButtonClassName: cx(classCombiner(styles, "previousButton")), previousClassName: cx(classCombiner(styles, "previous")), siblings: isMobileWidth ? 3 : 5, singlePageSearchData: singlePageSearchData, totalPages: totalPages, wrapperClassName: cx(classCombiner(styles, "crawlPagination"), "col-sm-12", "col-md-12", "col-lg-12") }) }))] })) }));
    }
    {
        // TODO Why?
    }
    return _jsx("div", { className: cx("container") });
};
const contactCrawlComponents = (renderableData) => renderIdentifierGeneric(ContactCrawlComponentsComponent, renderableData);
export { contactCrawlComponents };
